export class Team {
    $key?: string;
    code: string;
    name: string;
    players: {
        [key: string]: Player;
    };
    manual_players: {
        [key: string]: Player;
    };
}
export class Player {
    $key?: string;
    name: string;
    handicap: number;

}
